import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './Auth/auth.service';
import { DataService } from './Services/Data Service/data.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  private auth = inject(AuthService);
  private dataService = inject(DataService);

  constructor(public dialog: MatDialog) { }

  title = 'Procurement Vendor';

  ngOnInit(): void {
    // Single initialization: fetch current user once when app loads with existing token.
    // Components subscribe to DataService.currentUser$ instead of calling getCurrentUser().
    if (this.auth.getAccessToken() && this.auth.getUserEmail()) {
      this.dataService.getCurrentUser().subscribe({
        error: () => { /* init failed; guards/auth will handle */ }
      });
    }
  }
}
